import React from 'react';
import { useIntl } from 'react-intl';
import messages from '../messages';
import Range from './Range';

const WebPrice = ({ params, setParams }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="group">
      <h3>{formatMessage(messages.web_price)}</h3>
      <Range params={params} setParams={setParams} name="web_price" />
    </div>
  );
};

export default WebPrice;
